














































	import { Vue,Component } from 'vue-property-decorator'
	import { State,Action,namespace } from 'vuex-class'
	const basis = namespace('basis')
    @Component
    export default class Shelves extends Vue{
        title:string = '编辑货架'
		dialogStatus:boolean = false
		addStatus:boolean = true //是添加还是修改
		modifyId:string = '' // 点击修改的货架ID
		search = {
			site: ''
		}
        form:any = {
            nano: '',
            name: '',
            capacity: ''
        }
		@basis.State('shelves') shelves:any
		@basis.State('loading') loading:any 
		@basis.Action('getShelves') getShelves:any
		@basis.Action('addShelves') addShelves:any
		@basis.Action('deletShelves') deletShelves:any
		@basis.Action('modifyShelves') modifyShelves:any
		@basis.Action('restoreShelves') restoreShelves:any
		
		async created(){
			await this.getList()
		}
		async getList(){
			await this.getShelves(this.search)
		}
        // 编辑货架
        edit(e:any){
			this.form = {
				nano: e.nano,
				name: e.name,
				capacity: e.capacity
			}
			this.addStatus = false
			this.title = '编辑货架'
			this.modifyId = e._id
			this.dialogStatus = true
		}
		// 网点改变的时候
        changeSite(val:string){
            this.search.site = val
            this.getList()
        }
        // 打开添加货架弹窗
        showAdd(){
            this.title = '添加货架'
			this.dialogStatus = true
			this.addStatus = true
			this.form = {
				nano: '',
				name: '',
				capacity: ''
			}
		}
		// 添加货架
		async add(){
			if(this.form.nano != "" && this.form.name != ""){
				await this.addShelves({...this.form,...this.search})
				this.$message({  message: '添加成功',type: 'success' });
				this.dialogStatus = false
				this.getList()
			}else{
				this.$message({  message: '请填写正确的信息',type: 'warning' });
			}
		}
        //删除货架
        del(id:any){
            this.$confirm('确定需要删除此货架吗?', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
				this.deletShelves(id)
				this.getList()
            }).catch(() => {
                
            })
		}
		// 修改货架
		modify(id:any){
			this.modifyShelves({id: this.modifyId,data: this.form})
			this.$message({  message: '修改成功',type: 'success' });
			this.dialogStatus = false
			this.getList()
		}
		// 恢复删除货架
		async restoreDelete(id:string){
			const res = await this.restoreShelves(id);
			if(res){
				this.getList()
			}
		}
    }
